import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { doSamplesExist } from 'store/scenes/bootstrapCIs/samples/selectors';

import { getPrimaryParameterType } from 'store/scenes/bootstrapCIs/primaryParameter/selectors';
import { getSecondaryParameterName } from 'store/scenes/bootstrapCIs/secondaryParameter/selectors';

import BootstrapCIsComponent from './Component';

const BootstrapCIsContainer = props =>
  <BootstrapCIsComponent
    secondaryParameterSelected={props.secondaryParameterSelected}
    primaryParameterType={props.primaryParameterType}
    showRightAndBottomPanes={props.samplesExist}
  />;

BootstrapCIsContainer.propTypes = {
  samplesExist: PropTypes.bool.isRequired,
  secondaryParameterSelected: PropTypes.bool.isRequired,

  primaryParameterType: PropTypes.string
};

BootstrapCIsContainer.defaultProps = {
  primaryParameterType: null
};

const mapStateToProps = state => ({
  samplesExist: doSamplesExist(state),
  primaryParameterType: getPrimaryParameterType(state),
  secondaryParameterSelected: !!getSecondaryParameterName(state)
});

export default connect(mapStateToProps)(BootstrapCIsContainer);
